(function (once) {
  Drupal.behaviors.resourceDownloadLinkBehaviour = {
    attach: function (context, settings) {
      once('resourceDownloadLinkBehaviour', 'a.file', context).forEach(
        (element) => {
          element.addEventListener('click', (e) => {
            const resourceDialog = document.querySelector(
              'dialog.resource-popup-wrapper'
            );
            if (!resourceDialog) return;
            e.preventDefault();

            const closeButton = resourceDialog.querySelector(
              '.resource-popup-wrapper__close'
            );
            closeButton.addEventListener('click', () => {
              resourceDialog.close();
            });

            const existingDownloadButton = resourceDialog.querySelector(
              'a.resource-download-button'
            );
            if (existingDownloadButton) {
              existingDownloadButton.remove();
            }
            const downloadButton = document.createElement('a');
            downloadButton.classList.add('resource-download-button', 'btn');
            downloadButton.innerHTML = 'Continue to download';
            downloadButton.href = e.target.href;
            downloadButton.target = '_blank';
            downloadButton.addEventListener('click', () => {
              resourceDialog.close();
            });
            resourceDialog.appendChild(downloadButton);
            resourceDialog.showModal();
          });
        }
      );
    },
  };
})(once);
